import {Action, createReducer, on} from '@ngrx/store';
import * as UserActions from '@store/actions/user.action';
import {initialUserState, UserState} from '@store/state/user.state';
import {CustomerArticleStocks} from '@iw-shop/customer/interfaces/customer';

export const initialState: UserState = initialUserState()

const UserReducer = createReducer(
    initialState,
    on(UserActions.setUser, (state: UserState | {}, {userId: string}): UserState => {
        return {
            ...initialState,
            ...{
                isLoading: true
            }
        };
    }),
    on(UserActions.updateUserEmail, (state: UserState | {}, {email}: {email: string}): UserState => {
        return {
            ...state,
            email
        };
    }),


    on(UserActions.setUserSuccess, (state: UserState, {user}): UserState => {
        return {
            ...user
        };
    }),
    on(UserActions.setUserFailure, (state: UserState): UserState => {
        return initialState;
    }),
    on(UserActions.setMappedCustomers, (state: UserState): UserState => {
        return {
            ...state
        };
    }),

    on(UserActions.setMappedCustomersSuccess, (state: UserState, {mappedCustomers}): UserState => {
        return {
            ...state,
            ...{
                isLoading: false,
                mappedCustomers
            }
        };
    }),
    on(UserActions.updateMappedCustomer, (state: UserState, {customerId, mappedCustomer}): UserState => {

        return {
            ...state,
            ...{
                mappedCustomers: state.mappedCustomers?.map(
                    customer => {

                        if (customer.id == customerId) {
                            return mappedCustomer;
                        }
                        return customer;
                    }
                )
            }
        };
    }),
    on(UserActions.refreshMappedCustomer, (state: UserState, {customerId}): UserState => {
        return {
            ...state
        };
    }),
    on(UserActions.refreshMappedCustomerSuccess, (state: UserState, {mappedCustomer}): UserState => {
        return {
            ...state,
            ...{
                mappedCustomers: state.mappedCustomers?.map(
                    customer => {
                        if (customer.id == mappedCustomer.id) {
                            return mappedCustomer;
                        }
                        return customer;
                    }
                )
            }
        };
    }),
    on(UserActions.setCustomerArticleFavorites, (state: UserState, {customerId, favoritesList}): UserState => {
        return {
            ...state,
            ...{
                mappedCustomers: state.mappedCustomers?.map(
                    customer => {
                        if (customer.id == customerId) {

                            return {...customer, ...{favoritesList}};
                        }
                        return customer;
                    }
                )
            }
        };
    }),
    on(UserActions.setCustomerArticleStocks, (state: UserState, {customerId, stocks}): UserState => {
        return {
            ...state,
            ...{
                mappedCustomers: state.mappedCustomers?.map(
                    customer => {
                        if (customer.id == customerId) {
                            let articleStocks: CustomerArticleStocks[] = [];
                            if (customer.articleStocks) {
                                articleStocks = [...customer.articleStocks.filter(res => res.articleNumber !== stocks.articleNumber)];
                            }
                            articleStocks.push(stocks);
                            return {...customer, ...{articleStocks}};
                        }
                        return customer;
                    }
                )
            }
        };
    }),

    on(UserActions.addCustomerArticleFavorite, (state: UserState, {customerId, articleNumber}): UserState => {
        return {
            ...state,
            ...{
                mappedCustomers: state.mappedCustomers?.map(
                    customer => {
                        if (customer.id == customerId) {
                            let favoritesList: string[] = [];
                            if (customer.favoritesList) {
                                favoritesList = [...customer.favoritesList];
                            }
                            favoritesList.push(articleNumber);
                            return {...customer, ...{favoritesList}};
                        }
                        return customer;
                    }
                )
            }
        };
    }),
    on(UserActions.removeCustomerArticleFavorite, (state: UserState, {customerId, articleNumber}): UserState => {
        return {
            ...state,
            ...{
                mappedCustomers: state.mappedCustomers?.map(
                    customer => {

                        if (customer.id == customerId) {
                            let favoritesList: string[] = [];
                            if (customer.favoritesList) {
                                favoritesList = [...customer.favoritesList];
                            }
                            favoritesList = favoritesList.filter(res => res !== articleNumber);
                            return {...customer, ...{favoritesList}};
                        }
                        return customer;

                    }
                )
            }
        };
    }),
    on(UserActions.setMappedCustomersFailure, (state: UserState): UserState => {
        return {
            ...state,
            mappedCustomers: []
        };
    }),
    on(UserActions.resetUser, (state: UserState): UserState => {
        return {
            ...initialState
        };
    })
);

export function reducer(state: UserState | undefined, action: Action) {
    return UserReducer(state, action);
}
